<script lang="ts">
	import type { BlogPageMetadata } from '../types/BlogPageMetadata.ts';

	export let slug: string;
	export let metadata: BlogPageMetadata;
</script>

<a
	href={`/blog/${slug}`}
	class="bg-component-base flex min-h-[464px] min-w-[320px] max-w-md flex-col overflow-hidden border border-base shadow-md transition-shadow duration-300 ease-in-out rounded-container-token hover:border-hover hover:shadow-lg"
>
	<img alt={metadata.title} src={metadata.headerImage} class="h-48 w-full object-cover" />
	<div class="flex h-full flex-col p-6">
		<h2 class="mb-2 text-xl font-semibold text-surface-50">{metadata.title}</h2>
		<p class="mb-4 line-clamp-6 h-full">
			{metadata.description}
		</p>
		<div class="flex justify-between text-sm">
			<span>Tickrr Team</span>
			<span>{metadata.datePublished}</span>
		</div>
	</div>
</a>
